module.exports = __webpack_public_path__ + "img/header_logo_white.8ac1b93f.png";